
export interface RouteName {
  NoAccess: { n: string; p: string };
  NoFileSelected: { n: string; p: string };
  CMP: CMPRouteName;
}

export interface CMPRouteName {
  Dashboard: { n: string; p: string };
  EoiApply: { n: string; p: string };
  EoiReview: { n: string; p: string };
  Committee: { n: string; p: string };
  General: { n: string; p: string };
  LoginPage: { n: string; p: string };
  LogoutPage: { n: string; p: string };
  Main: { n: string; p: string };
}


export const RouteN: RouteName = {
  NoAccess: { n: 'no-access', p: '/no-access' },
  NoFileSelected: { n: 'NoFileSelected', p: '/no-file-selected' },
  CMP: {
    Dashboard: { n: 'Dashboard', p: '/dashboard' },
    EoiApply: { n: 'EoiApply', p: '/eoi-apply' },
    EoiReview: { n: 'EoiReview', p: '/eoi-review' },
    Committee: { n: 'Committee', p: '/committee' },
    General: { n: 'General', p: '/general' },
    LoginPage: { n: 'login', p: '/check-auth' },
    LogoutPage: { n: 'logout', p: '/signout' },
    Main: { n: 'cmp-main', p: '/' },
  }
};
